import React, { useEffect, useState } from 'react';
import {
    Table, TableHead, TableRow, TableCell, TableBody,
    Switch, Pagination, Typography, CircularProgress,
    Paper, Box, Stack, useTheme, useMediaQuery
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import { BACKEND_BASE_URL } from '../config';
import api from '../components/api';
import 'react-toastify/dist/ReactToastify.css';

const PAGE_SIZE = 150;

const FeedbackPage = () => {
    const [feedbacks, setFeedbacks] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [updatingId, setUpdatingId] = useState(null);

    const token = localStorage.getItem('access_token');
    const user = JSON.parse(localStorage.getItem('user'));
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const fetchFeedbacks = async (pageNum = 1) => {
        setLoading(true);
        try {
            const res = await api.get(
                `${BACKEND_BASE_URL}/api/feedbacks/?limit=${PAGE_SIZE}&offset=${(pageNum - 1) * PAGE_SIZE}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setFeedbacks(res.data.results || []);
            setCount(Math.ceil(res.data.count / PAGE_SIZE));
        } catch (err) {
            console.error('Failed to load feedbacks:', err);
            toast.error('Failed to load feedbacks ⚠️');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeedbacks(page);
    }, [page]);

    const toggleViewed = async (id, current) => {
        setUpdatingId(id);
        try {
            await api.patch(
                `${BACKEND_BASE_URL}/api/feedbacks/${id}/`,
                {
                    viewed: !current,
                    viewer: !current ? user?.id : null,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            toast.success(`Marked as ${!current ? 'Viewed' : 'Unviewed'}! 🎯`);
            fetchFeedbacks(page);
        } catch (err) {
            console.error('Error updating viewed status:', err);
            toast.error('Failed to update viewed status ⚠️');
        } finally {
            setUpdatingId(null);
        }
    };


    return (
        <Box p={isMobile ? 2 : 4}>
            <Stack spacing={2}>
                <Typography variant="h5" fontWeight={600}>
                    Feedback Submissions
                </Typography>

                <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    {loading ? (
                        <Box display="flex" justifyContent="center" p={4}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={{ overflowX: 'auto' }}>
                            <Table stickyHeader size="small">
                                <TableHead >
                                    <TableRow >
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>S.No.</b></TableCell>
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>Name</b></TableCell>
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>Email</b></TableCell>
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>Feedback</b></TableCell>
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>Submitted At</b></TableCell>
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>Viewed</b></TableCell>
                                        <TableCell sx={{ backgroundColor: '#152F8F', color: 'white' }} align="center"><b>Viewer</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {feedbacks.map((fb, index) => (
                                        <TableRow key={fb.id}>
                                            <TableCell align="center">{(page - 1) * PAGE_SIZE + index + 1}</TableCell>
                                            <TableCell align="center">{fb.name?.trim() || 'Anonymous User'}</TableCell>
                                            <TableCell align="center">{fb.email?.trim() || '—'}</TableCell>
                                            <TableCell align="center">{fb.message}</TableCell>
                                            <TableCell align="center">
                                                {new Date(fb.submitted_at).toLocaleString(undefined, {
                                                    dateStyle: 'medium',
                                                    timeStyle: 'short',
                                                    hour12: true,
                                                })}
                                            </TableCell>


                                            <TableCell align="center">
                                                <Switch
                                                    checked={fb.viewed}
                                                    onChange={() => toggleViewed(fb.id, fb.viewed)}
                                                    color="primary"
                                                    disabled={updatingId === fb.id}
                                                />
                                            </TableCell>
                                            <TableCell align="center">{fb.viewer_email || '—'}</TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    )}
                </Paper>

                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={count}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                        color="primary"
                        size={isMobile ? 'small' : 'medium'}
                    />
                </Box>

                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="light"
                    toastStyle={{
                        backgroundColor: '#f9f9f9',
                        color: '#333',
                        fontSize: '14px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                    }}
                    bodyStyle={{
                        padding: '10px 12px',
                    }}
                />
            </Stack>
        </Box>
    );
};

export default FeedbackPage;
